import axios from 'axios';
import user from '../utils/user';

export default {
  async getPolicyByNumber(
    policyNumber,
    last = false,
    activated = false,
    checkAllowQuotation = false,
  ) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/policy/auto/${policyNumber}?last=${last}&activated=${activated}&checkAllowQuotation=${checkAllowQuotation}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getOriginalPolicyByNumber(policyNumber) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/policy/auto/${policyNumber}/original-policy`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getPolicyStatusByNumber(policyNumber) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/policy/${policyNumber}/status`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
